import axios from 'axios'
import { isValidNodeID } from '../utils/validation'

export default ({ nodeID }) => {
  // Validate nodeID
  if (!isValidNodeID(nodeID)) {
    console.error('Invalid nodeID provided:', nodeID)
    return Promise.reject(new Error('Invalid nodeID'))
  }

  // Use environment variable for API base URL
  const apiBaseUrl = process.env.VUE_APP_EDUCATION_LAMBDA_API_BASE_URL

  const requestUrl = `${apiBaseUrl}/api/node/${nodeID}`

  if (process.env.NODE_ENV === 'development' || process.env.VUE_APP_DEBUG === 'true') {
    console.log('apiPropertyFetcher requestUrl: ', requestUrl)
  }

  // We need a copy of Axios that doesn't have the general authentication credentials.
  const contentWarehouseAxios = axios.create({
    'headers': null
  })


  // Response interceptor to log errors to New Relic
  contentWarehouseAxios.interceptors.response.use((response) => {
    return response
  }, (error) => {
    if (window.newrelic) {
      window.newrelic.noticeError(error, {
        api: error.config?.url,
        method: error.config?.method,
        status: error.response?.status
      })
    }
    return Promise.reject(error)
  })
  return contentWarehouseAxios
    .get(requestUrl)
    .then(({ data }) => {
      return data
    })
    .then(({ success, data }) => {
      let properties = null

      if (success === true) {
        properties = data
      }

      return properties
    })
    .catch((error) => {
      if (process.env.NODE_ENV === 'development' || process.env.VUE_APP_DEBUG === 'true') {
        console.log('apiPropertyFetcher error: ', error)
      }
    })
}
